module.exports = {
  add_more: ' Aggiungi altro',
  provideFullAddress: "Si prega di fornire l'indirizzo completo",
  dropdownBoth: 'Compila tutti i campi',
  dropdownDay: 'Prego di selezionare la data desiderata',
  dropdownTime: "Prego di selezionare l'orario desiderato",
  pictureDescription: 'Aggiungi descrizione della foto (opzionale)',
  changeEmail: 'Cambia',
  dontChangeEmail: 'Non cambiare',
  yes: 'Si',
  no: 'No',
  'next-step': 'Avanti',
  'next-step-wizard': 'Avanti',
  step: 'Passo',
  off: 'av',
  'first-step-wizard': 'Iniziamo',
  'last-step': 'Richiedi preventivi gratuiti e senza impegno!',
  'go-back': 'Torna indietro',
  'go-back-wizard': 'Indietro',
  understood: 'Ho capito!',
  'company-autocomplete-label': '',
  'company-placeholder': 'Nome azienda',
  'company-label': 'Azienda',
  'address-placeholder': 'Indirizzo',
  address_no_number_placeholder: 'Indirizzo',
  'address-label': 'Indirizzo',
  'address-street-number-label': 'N. civico',
  'address-street-number-placeholder': '1A',
  'address-no-street-number-label': 'Manca il numero civico',
  'address-not-found': 'Indirizzo non trovato',
  'address-no-match': 'Nessun risultato',
  'address-choose-from': 'Seleziona da più indirizzi',
  'address-invalid': 'Indirizzo non è valido',
  'address-missing': "Manca l'indirizzo",
  'address-missing-street-number': 'Manca il numero civico',
  address_alert: "Hai inserito l'indirizzo corretto?",
  address_missing_city: 'Manca la città',
  'phone-invalid-length': 'Numero di cellulare deve avere 10 cifre.',
  'zip-error': 'Inserisci il CAP',
  'zip-label': 'Codice postale',
  'zip-does-not-exist': 'CAP non esiste',
  zip_placeholder: '20135',
  'name-label': 'Nome & Cognome',
  'date-format': 'ggmmaa',
  'date-label': 'Data (6 cifre)',
  'birthdate-label': 'Data di nascita (6 cifre)',
  'national-identity-label': 'Data di nascita',
  'national-identity-placeholder': '11 siffer',
  'national-identity-invalid': 'Codice fiscale non è valido',
  'national-identity-identical':
    'Medlånetakers fødselsnummer kan ikke være identisk med hovedsøkers',
  'bank-account-label': 'Conto bancario',
  'measuring-id-invalid': 'ID utente non valido',
  'bank-account-placeholder': '11 siffer',
  'bank-account-invalid': 'Numero di conto bancario non valido',
  'organization-identity-label': 'Partita IVA',
  'organization-identity-placeholder': '11 cifre',
  'organization-identity-invalid': 'Partita IVA non valida',
  'date-invalid': 'Data non valida',
  'name-placeholder': 'Mario Rossi',
  'name-invalid': 'Nome non valido',
  'email-alert-message': 'Hai inserito un indirizzo e-mail corretto?',
  'email-label': 'Email',
  'email-placeholder': 'nome@dominio.it',
  'email-does-not-exist': "L' indirizzo e-mail inserito non è valido",
  'email-invalid': "L' indirizzo e-mail inserito non è corretto",
  email_did_you_mean: 'Intendevi',
  'fetching-information': 'Recuperare informazioni',
  'comment-label': 'Ulteriori informazioni',
  'comment-placeholder':
    'Opzionale: Inserisci informazioni su per esempio desideri, esigenze o considerazioni speciali.',
  'phone-alert-message': 'Hai inserito un numero corretto?',
  'phone-label': 'Cellulare',
  'phone-invalid': 'Numero di cellulare non valido',
  'phone-must-begin-with-+': 'Il numero di telefono deve iniziare con +',
  'phone-foreign': 'Numero di telefono internazionale',
  'phone-placeholder': '123456789',
  'phone-foreign-placeholder-prefix': '+39 ',
  'error-x-numbers': 'Deve essere composto da --x-- cifre',
  'error-x-letters': 'Deve essere composto da --x-- caratteri',
  'error-min-rooms': 'Seleziona almeno una stanza',
  'error-min-x-letters': 'Deve essere composto da --x-- lettere',
  'error-min-x-numbers': 'Deve essere composto da almeno --x-- cifre',
  'error-max-x-numbers': 'Deve essere composto da un massimo di --x-- cifre',
  'error-inbetween-numbers': 'Deve essere composto da --x-----y cifre',
  'error-must-consist-of-x-letters': 'Deve contenere almeno --x-- lettere',
  'error-mandatory': 'Deve essere compilato',
  'error-choose': 'Seleziona almeno --x-- opzione/i',
  'error-min-age': 'Le offerte purtroppo vengono fornite solo ai clienti con più di --x-- anni',
  'error-must-accept': 'Deve accettare',
  'error-only-digits': 'Solo numeri',
  privacy:
    ' <strong>  La tua privacy è protetta: </strong> tutti i dati del modulo sono crittografati tramite una connessione sicura.',
  'privacy-policy': `<h4>Informativa sulla privacy</h4><p>La privacy è molto importante per noi di --x--. Come utente devi essere sicuro che le informazioni che inserisci non vengano utilizzate per scopi diversi da quelli a cui hai dato il consenso e che siano archiviate in modo sicuro.</p><p>I dati che inserisci sono il minimo di cui i fornitori hanno bisogno per poterti fornire offerte specifiche in base alle tue esigenze. Non saranno utilizzati per altro che fornirti tali offerte per un periodo di tempo ragionevole, in base alle tue scelte e preferenze per la forma e il tempo di comunicazione, ove applicabile, oltre al necessario lavoro amministrativo ad esso connesso.</p><p>I dati vengono elaborati dalla società IT norvegese Nettbureau AS che possiede e gestisce --x--, oltre ai relativi fornitori.</p><p>Le informazioni personali su di te verranno elaborate solo per scopi legittimi e verranno cancellate o rese anonime quando non avremo più una base per elaborarle.</p><p>L'agenzia online garantisce che le informazioni personali su di te siano protette in modo soddisfacente.</p><p>L'agenzia online garantisce la comunicazione con gli utenti tramite crittografia.</p> <p> Ulteriori informazioni trovi nella nostra <a href="--y--" target="__blank">informativa sulla privacy completa</a></p>blank">fullstendige personvernpolicy</a></p>__`,
  close: 'Chiudi',
  error_radio_button: 'Devi selezionare un campo',
  invalid_day: 'Data non valida',
  invalid_day_in_month: 'Questa data non esiste in questo mese',
  invalid_month: 'Mese non valido',
  invalid_year: 'Anno non valido',
  label_birthdate: 'Data di nascita',
  label_date: 'Data',
  label_day: 'Giorno',
  label_month: 'Mese',
  label_year: 'Anno',
  locale: 'it-IT',
  new_locale: 'it-IT',
  missing_date: 'Data mancante',
  missing_month: 'Mese mancante',
  missing_year: 'Anno mancante',
  'datepicker-button': 'Seleziona la data',
  email_wrong_user_account: 'Sei sicuro che il tuo account e-mail è scritto correttamente?',
  email_wrong_email_address: 'Sei sicuro che il tuo indirizzo e-mail è valido?',
  not_valid_municipality: 'Commune non valido',
  not_valid_state: '',
  'invalid-file-size': 'La dimensione massima del file è',
  'invalid-file-type': 'Tipi di file illegali, tipi di file legali',
  'drop-files-first': 'Rilascia file qui',
  'drop-files-last': 'clicca per selezionare/fare una foto',
  'sms-verification-label': 'Verifica Tramite SMS',
  'sms-verification-tinyLabel':
    'Inserisci il codice di verifica appena inviato al tuo numero di telefono --xx-- tramite SMS. La verifica garantisce una rapida e corretta elaborazione della tua richiesta.',
  'sms-verification-error-message': 'Codice errato',
  'sms-verification-code-not-received-first': 'Non hai ricevuto alcun codice? Clicca ',
  'sms-verification-code-not-received-link': 'qui',
  'sms-verification-code-not-received-last': ' per inviarne un altro.',
  'sms-verification-code-is-sent-again': 'Il codice è stato inviato nuovamente.',
  'sms-verification-code-retry-error':
    'Troppi tentativi, per favore attendi 30 secondi prima di riprovare.',
  'leazard-two-factor-header': 'Quasi finito!',
  'leazard-two-factor-help-text':
    "Ti abbiamo inviato un codice di verifica via SMS dal numero +47 59 44 45 00. L'abbiamo inviato per confermare che il numero appartiene a te. Non riceverai ulteriori SMS da parte nostra.",
  'leazard-two-factor-submit': 'Completa',
  'leazard-two-factor-label': 'Inserisci il codice per confermare la tua identità.',
  'leazard-loading-text': 'Processando informazioni',
  'recaptcha-disclaimer': 'Questo sito web è protetto da reCAPTCHA.',
};
